import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TDropdownItem } from '../../form/model/form.model';
import * as uuid from 'uuid';
import { TTableVirtualScrollConfig } from '../../table/models/table.type';

@Component({
  selector: 'monorepo-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
})
export class MultiSelectDropdownComponent {
  @Input() virtualScroll?: TTableVirtualScrollConfig = undefined;
  _dropdownList: TDropdownItem[] = [];
  _dropdownConfig = {
    isMultiSelect: true,
    isClearOption: false,
    isDisabled: false,
    placeHolder: '',
  };
  @Input() set dropdownConfig(config: {
    isMultiSelect?: boolean;
    isClearOption?: boolean;
    isDisabled?: boolean;
    placeHolder?: string;
  }) {
    this._dropdownConfig = { ...this._dropdownConfig, ...config };
  }

  @Input() set dropdownData(dropdowns: {
    items: TDropdownItem[];
    defaultSelectedItems?: number | string | (number | string)[];
  }) {
    const defaultSelectedItems = dropdowns.defaultSelectedItems;
    this._dropdownList = !defaultSelectedItems
      ? [...dropdowns.items]
      : dropdowns.items.map((item) => {
          return {
            ...item,
            isSelected: Array.isArray(defaultSelectedItems)
              ? defaultSelectedItems.includes(item.value)
              : defaultSelectedItems === item.value,
          };
        });
    this.filteredDropdownList = [...this._dropdownList];
    this.#updateSelectedDropdownList(this.filteredDropdownList);
  }

  @Output() selectedList = new EventEmitter<TDropdownItem['value'][]>();

  popverId = uuid.v4();
  isDropdownOpen = false;
  filteredDropdownList: TDropdownItem[] = [];
  selectedDropdownList: TDropdownItem[] = [];
  dropdownChevron = 'assets/common/chevron-close-block.svg';

  openDropdown() {
    if (!this._dropdownConfig.isDisabled) {
      this.isDropdownOpen = true;
    }
  }

  onSearch($event: any) {
    const searchValue = ($event.target as HTMLInputElement).value.toLowerCase();
    const filteredDropdownList = this._dropdownList
      .map((item) => {
        return {
          ...item,
        };
      })
      .filter(
        (item) =>
          (item.value.toString() + '%' + (item.displayName || '').toString())
            .toLocaleLowerCase()
            .indexOf(searchValue) >= 0,
      );
    filteredDropdownList.forEach((filteredDropdownItem) => {
      const index = this.selectedDropdownList.findIndex((item) => item.value === filteredDropdownItem.value);
      if (index > -1) {
        filteredDropdownItem.isSelected = true;
      } else filteredDropdownItem.isSelected = false;
    });
    this.filteredDropdownList = filteredDropdownList;
  }

  onClearSearch() {
    const filteredDropdownList = this._dropdownList.map((item) => {
      return {
        ...item,
      };
    });
    filteredDropdownList.forEach((filteredDropdownItem) => {
      const index = this.selectedDropdownList.findIndex((item) => item.value === filteredDropdownItem.value);
      if (index > -1) {
        filteredDropdownItem.isSelected = true;
      } else filteredDropdownItem.isSelected = false;
    });
    this.filteredDropdownList = filteredDropdownList;
  }

  handlePopOverDismiss() {
    this.isDropdownOpen = false;
    this.filteredDropdownList = this.#getFilteredDropdownListWithoutSearch();
  }

  #updateSelectedDropdownList(filteredDropdownList: TDropdownItem[]) {
    this.selectedDropdownList = filteredDropdownList.filter((item) => item.isSelected);
  }

  #getFilteredDropdownListWithoutSearch() {
    const filteredDropdownList = this._dropdownList.map((item) => {
      return { ...item };
    });
    filteredDropdownList.forEach((filteredDropdownItem) => {
      const index = this.selectedDropdownList.findIndex((item) => item.value === filteredDropdownItem.value);
      if (index > -1) {
        filteredDropdownItem.isSelected = true;
      } else filteredDropdownItem.isSelected = false;
    });
    return filteredDropdownList;
  }

  #updateFilteredDropdownList(selectedOrDeSelectedValue: string | number, isChecked: boolean) {
    const filteredDropdownList = this.#getFilteredDropdownListWithoutSearch();
    const filteredDropdownListWithoutSearch = filteredDropdownList.map((item) => {
      if (item.value === selectedOrDeSelectedValue) {
        return {
          ...item,
          isSelected: isChecked,
        };
      } else if (!this._dropdownConfig.isMultiSelect) {
        return {
          ...item,
          isSelected: false,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    this.#updateSelectedDropdownList(filteredDropdownListWithoutSearch);

    const filteredDropdownListWithSearch = this.filteredDropdownList.map((item) => {
      if (item.value === selectedOrDeSelectedValue) {
        return {
          ...item,
          isSelected: isChecked,
        };
      } else if (!this._dropdownConfig.isMultiSelect) {
        return {
          ...item,
          isSelected: false,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    this.filteredDropdownList = filteredDropdownListWithSearch;
    this.selectedList.emit(this.selectedDropdownList.map((item) => item.value));
  }

  onSelectOrDeselect($event: any, selectedOrDeSelectedValue: string | number) {
    this.isDropdownOpen = this._dropdownConfig.isMultiSelect;
    this.#updateFilteredDropdownList(selectedOrDeSelectedValue, $event.target.checked);
  }

  onDeSelectItemFromClearCrossIcon($event: any, deSelectedValue: string | number) {
    $event.stopPropagation();
    if (!this._dropdownConfig.isDisabled) this.#updateFilteredDropdownList(deSelectedValue, false);
  }
}
